/*!
 * tagselector.js
 * 
 */
(function($) {
    $.tagselector = function(element, options) {

        var defaults = {
        }

        var plugin = this;

        plugin.settings = {};

        var $element = $(element);
        var element = element;

        plugin.init = function() {
            plugin.settings = $.extend({}, defaults, options);
        }

        plugin.addtag = function(tagid, tagvalue) {

            if ($element.find(".tag[data-id="+tagid+"]").length > 0) {
                return true;
            }

            $element.append(
                $('<li>')
                .addClass('tag')
                .attr('data-id', tagid)
                .append(
                    $('<span>').text(tagvalue),
                    $('<a>')
                    .text('')
                    .addClass('remove')
                    .attr('href', '#')
                    .on('click', function() {
                        return $element.data("tagselector").removetag(tagid);
                    })
                )
            );
            return true;
        };

        plugin.removetag = function(tagid) {
            $element.find(".tag[data-id="+tagid+"]").remove();
            return true;
        };

        plugin.gettags = function() {
            var tags = [];
            $element.find(".tag").each(function(key, value) {
                tags.push({
                    "id" : $(value).attr("data-id"),
                    "value" : $(value).find('span').text()
                })
            });
            return tags;
        };

        plugin.reset = function() {
            $element.html(null);
            return true;
        };

        plugin.init();
    }

    $.fn.tagselector = function(options) {
        return this.each(function() {
            if (undefined == $(this).data('tagselector')) {
                var plugin = new $.tagselector(this, options);
                $(this).data('tagselector', plugin);
            }
        });
    }

}( jQuery ));